
import React from "react";

import project1 from "../../assets/projects/project1.jpeg";
import project2 from "../../assets/projects/project2.jpeg";
import project3 from "../../assets/projects/project3.jpeg";
import project4 from "../../assets/projects/project4.jpeg";
import project5 from "../../assets/projects/project5.jpeg";

import HeroBanner from "../../components/HeroBanner/HeroBanner";
import ContactForm from "../../components/Forms/ContactForm";
import ImageGrid from "../../components/Home/imageGrid/imageGrid";

const Projects = () => {
  const title = "Projects";
  const description =
    " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi,accusamus? Nisi, pariatur.";

  return (
    <div>
      <HeroBanner title={title} subtitle={description} />
      <div className="py-8">
        <h2 className="text-3xl font-bold text-center mb-8">
          EXPLORE OUR RECENT PROJECT
        </h2>

          <ImageGrid
            image1={project1}
            image2={project2}
            image3={project3}
            image4={project4}
            image5={project5}
          />
      
      </div>
      <div className=" py-20 p-2 md:p-20 ">
        <ContactForm/>
      </div>
    </div>
  );
};

export default Projects;



// import React from "react";

// import project1 from "../../assets/projects/project1.jpeg";
// import project2 from "../../assets/projects/project2.jpeg";
// import project3 from "../../assets/projects/project3.jpeg";
// import project4 from "../../assets/projects/project4.jpeg";
// import project5 from "../../assets/projects/project5.jpeg";
// import HeroBanner from "../../components/HeroBanner/HeroBanner";
// import ContactForm from "../../components/Forms/ContactForm";

// const Projects = () => {
//   const title = "Projects";
//   const description =
//     " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi,accusamus? Nisi, pariatur.";

//   return (
//     <div>
//       <HeroBanner title={title} subtitle={description} />
//       <div className="py-8 ">
//         <h2 className="text-3xl font-bold text-center mb-8">
//           EXPLORE OUR RECENT PROJECT
//         </h2>

//         <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-10 p-5 h-full">
//           {/* left image  */}
//           <div className="w-full  h-full">
//             <img
//               src={project1}
//               alt="Project 1"
//               className="w-full h-full object-cover"
//             />
//           </div>
//           {/* right image  */}
//           <div className="flex w-full lg:w-1/2 gap-10 justify-center  md:gap-4 flex-col  ">
//             <div className="flex flex-col md:flex-row gap-10">
//               <img
//                 src={project2}
//                 alt="Project 2"
//                 className="h-48  w-full xl:h-80  object-cover"
//               />
//               <img
//                 src={project3}
//                 alt="Project 3"
//                 className="h-48  w-full xl:h-80  object-cover"
//               />
//             </div>
//             <div className="flex flex-col md:flex-row gap-10">
//               <img
//                 src={project4}
//                 alt="Project 4"
//                 className="h-48  w-full xl:h-80 object-cover"
//               />
//               <img
//                 src={project5}
//                 alt="Project 5"
//                 className="h-48 w-full xl:h-80  object-cover"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className=" py-20 p-2 md:p-20 ">
//         <ContactForm/>
//       </div>
//     </div>
//   );
// };

// export default Projects;